import dayjs from "dayjs";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

import { EventRow } from "api/event";
import googleCalendarIcon from "assets/icons/google-calendar.png";
import styles from "./googleCalendarDialog.module.scss";

export interface GoogleCalendarDialogProps {
  event: EventRow;
  onClose: () => void;
  onHide: () => void;
  open: boolean;
}

function GoogleCalendarDialog(props: GoogleCalendarDialogProps) {
  const { event, onClose, onHide, open } = props;

  const startDate = dayjs(event.start_date).second(0);
  const endDate = dayjs(event.end_date).second(0);
  const dates = `dates=${startDate.format("YYYYMMDDTHHmmss")}Z%2F${endDate.format("YYYYMMDDTHHmmss")}`;

  /**
   * Handle confirmation to add event to google calendar
   */
  function handleConfirmation(): void {
    const url = `http://www.google.com/calendar/event?action=TEMPLATE&${dates}&text=${event.name}&location=${
      event.location?.name ?? ""
    }&details=${event.details}`;

    window.open(url.replace(/\s+/g, "%20"));
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='google-calendar' maxWidth='xs' fullWidth>
      <DialogTitle id='google-calendar'>
        <img alt='calendar icon' className={styles.googleCalendarIcon} src={googleCalendarIcon} />
        Add to Google Calendar?
      </DialogTitle>
      <DialogContent>
        You can add this event to your Google Calendar events. If you press on{" "}
        <Typography component='span' color='primary'>
          <b>HIDE</b>
        </Typography>
        , this option won&#39;t appear in the future but you can enable it from your account settings.
      </DialogContent>
      <DialogActions>
        <Button onClick={onHide}>Hide</Button>
        <Button onClick={handleConfirmation}>Yes</Button>
        <Button onClick={onClose}>No</Button>
      </DialogActions>
    </Dialog>
  );
}

export default GoogleCalendarDialog;
